import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { AnswerContent as TAnswerContent } from "@/schema/console/evaluation-reports/AnswerContent";
import AnswerContent from "@/src/console/(auth)/_components/EvaluationReport/AnswerContent/AnswerContent";
import { QuestionCircle20Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

interface TragetQuestionsDialogProps {
  target: string;
  description: string;
  answerContents: TAnswerContent[];
}

function TargetQuestionsDialog({
  target,
  description,
  answerContents,
}: TragetQuestionsDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog>
      <DialogTrigger className=" text-sm font-medium text-cyan-600 hover:underline hover:cursor-pointer">
        {t("view-questions")}
      </DialogTrigger>
      <DialogContent className="min-w-[700px]">
        <DialogHeader>
          <DialogTitle>{t("questions-associated-with-target")} {target}</DialogTitle>
        </DialogHeader>
        <ScrollArea
          style={{
            height: "calc(100vh - 96px)",
          }}
        >
          <div className=" flex flex-col">
            <div className=" flex flex-col p-5 border-b border-b-cool-gray-200 space-y-2">
              <p className=" text-lg font-medium text-cool-gray-700">
                {t("target")} {target}
              </p>
              <p className=" text-sm font-normal text-cool-gray-700">
                {description}
              </p>
              <div className=" flex flex-row space-x-[6px] items-center">
                <QuestionCircle20Regular />
                <p className=" text-sm font-normal text-cool-gray-600">
                  {answerContents.length} {t("associated-questions")}
                </p>
              </div>
            </div>
            {answerContents.map((answerContent, index) => (
              <AnswerContent
                key={answerContent.id}
                index={index}
                answerContent={answerContent}
              />
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}

export default TargetQuestionsDialog;
